import axios from 'axios';
import toast from 'react-hot-toast';

const API_URL = import.meta.env.VITE_API_URL || (import.meta.env.DEV ? 'http://localhost:3000/api' : '/api');

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    // CSRF or other headers if needed can go here
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Si el token expira o es inválido, cerrar sesión
      localStorage.removeItem('currentUser');
      window.location.href = '/';
    } else if (error.response && (error.response.status === 502 || error.response.status === 503 || error.response.status === 504)) {
      window.dispatchEvent(new CustomEvent('server-error'));
      toast.error('El servidor está en mantenimiento o reiniciando.');
    } else if (error.response && error.response.status >= 500) {
      toast.error('Error interno del servidor.');
    } else if (!error.response) {
      window.dispatchEvent(new CustomEvent('server-error'));
      toast.error('No se pudo conectar con el servidor.');
    }
    return Promise.reject(error);
  }
);

export default api;
